import { tracking } from './analytics/analytics';

export const useReservationTracking = () => {
  const { trackEvent } = tracking();

  const trackTripEvent = (data: {
    event:
      | 'add_to_cart'
      | 'begin_checkout'
      | 'reservation_add_invoice_data'
      | 'reservation_submit_reservation'
      | 'reservation_add_travellers_data'
      | 'reservation_add_services_data';
    value: number;
  }) => {
    const prices = window.RESERVATION_STORE.prices.map((item) => item.price);
    const defaultPrice =
      window.RESERVATION_STORE.prices.find((item) => item.category === 'CATEGORY_TRIP_FULL')
        ?.price ?? 0;

    const pricesObject =
      prices.length === 1
        ? {
            price: defaultPrice,
          }
        : {
            price_from: Math.min(...prices),
          };

    trackEvent({
      event: data.event,
      items: [
        {
          item_id: String(window.RESERVATION_STORE.tripBaseInfo.id),
          item_name: window.RESERVATION_STORE.tripBaseInfo.name,
          trip_date_id: String(window.RESERVATION_STORE.tripBaseInfo.tripDate.id),
          start_date: window.RESERVATION_STORE.tripBaseInfo.tripDate.start_date,
          end_date: window.RESERVATION_STORE.tripBaseInfo.tripDate.end_date,
          quantity: 1,
          ...pricesObject,
        },
      ],
      value: data.value,
    });
  };

  return {
    trackTripEvent,
  };
};
